import React from 'react';
import get from 'lodash/get';
import each from 'lodash/each';
import forEach from 'lodash/forEach';
// import map from 'lodash/map'; TODO: for pdf preview
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
// import numDesc from 'helpers/numDesc';
import formatDate, { difDays } from 'helpers/formatDate';
import { Checkbox, Input, PhoneInput } from 'containers/form';
import BillingContainer, { BillingProducts, AbstractOrderBlock } from 'containers/billing';
// import contentBlock from 'containers/content-block';
import Link from 'components/link';
import Row, { Col } from 'components/row';
import Container from 'components/container';
import Icon, { iconTypes } from 'components/icon';
import Button from 'components/button';
import Notification from 'components/notification';
import Tooltip from 'components/tooltip';
/* TODO: for pdf preview
import Slick from 'components/slick-slider';
import Image from 'components/image';
*/

import { renderStocksLC } from 'src-sites/bild/section-project/render-stocks';
import BannerTelegram from 'src-sites/bild/blocks/static/banner-telegram';
// import BottomBlockWrapper from 'src-sites/bild/blocks/bottomBlockWrapper';
// import blocksConfig from 'src-sites/bild/blocks/config';
import linksBild from 'src-sites/bild/links';
import linksBildControl from 'src-sites/bildcontrol/links';

import blockConclusionMain, { blockConclusionAll } from './block-conclusion';
import imgShieldGray from '../assets/shieldGray.png';
import imgShieldRed from '../assets/shieldRed.png';
import imgShieldYellow from '../assets/shieldYellow.png';
import imgShieldGreen from '../assets/shieldGreen.png';
import imgShieldBlue from '../assets/shieldBlue.png';
import imgBannerPhone from '../assets/banner/320.jpg';
import imgBannerTablet from '../assets/banner/768.jpg';
import imgBanner from '../assets/banner/1280.jpg';

import translates from '../project-i18n';

const bemClasses = new Bem('project');

const pointLevel = {
  NA: { img: imgShieldGray },
  lowLevel: { img: imgShieldRed },
  mediumLevel: { img: imgShieldYellow },
  highLevel: { img: imgShieldGreen },
  readyStatus: { img: imgShieldBlue }
};

const products = {
  allProducts: [
    BillingProducts.RELIABILITY_ACTUALIZE,
    BillingProducts.RELIABILITY_REPORT,
    BillingProducts.RELIABILITY_URGENCY,
    BillingProducts.RELIABILITY_CONSULTATION,
    BillingProducts.RELIABILITY_NEW_REPORT
  ],
  reportNA: [
    BillingProducts.RELIABILITY_NEW_REPORT
  ],
  reportNAAndConsult: [
    BillingProducts.RELIABILITY_NEW_REPORT,
    BillingProducts.RELIABILITY_CONSULTATION,
  ],
  onlyReport: [
    BillingProducts.RELIABILITY_REPORT
  ],
  actualization: [
    BillingProducts.RELIABILITY_ACTUALIZE,
    BillingProducts.RELIABILITY_REPORT
  ],
  actualizationAndConsult: [
    BillingProducts.RELIABILITY_ACTUALIZE,
    BillingProducts.RELIABILITY_REPORT,
    BillingProducts.RELIABILITY_CONSULTATION,
  ],
  actualizationUrgency: [
    BillingProducts.RELIABILITY_ACTUALIZE,
    BillingProducts.RELIABILITY_REPORT,
    BillingProducts.RELIABILITY_URGENCY,
  ],
  actualizationAndConsultAndUrgency: [
    BillingProducts.RELIABILITY_ACTUALIZE,
    BillingProducts.RELIABILITY_REPORT,
    BillingProducts.RELIABILITY_CONSULTATION,
    BillingProducts.RELIABILITY_URGENCY,
  ]
};

export default function blockMakeOrder() {
  const { i18n } = this;
  /* pdf preview
  const { project = {}, orderId, selectedProducts, pdfPreviewImages } = this.props; */
  const { project = {}, orderId, stocksLC, promocode } = this.props;
  const {
    points = {}, reliability_to_publish, display_name, status_ready,
    reliability_date_first_published, reliability_date_actualize
  } = project;
  const pointsFilled = get(points, 'investorConfidence.filled');
  const pointsAll = get(points, 'investorConfidence.all');
  const level = get(points, 'level');
  const levelNA = level === 'NA';
  const textChangeStatus = status_ready ? i18n('putIntoOperation') : i18n('newBuildingReliabilityIndex');
  const pointsTxt = reliability_to_publish ? (
    <>
      <span {...bemClasses('text', 'pointsAll')} children={`${i18n('ofText')} ${pointsAll}`} />
      <span {...bemClasses('text', 'points')} children={pointsFilled} />
    </>
  ) : <span {...bemClasses('text', 'points')} children={i18n('naText')} />;
  const firstPreviewPage = (
    <div {...bemClasses('pdf', { [level]: level })}>
      <div {...bemClasses('logo')}>
        <span {...bemClasses('logoContent')}>
          <Icon {...bemClasses('icon', 'icon')} type={iconTypes.logoBildControl} />
          <Icon {...bemClasses('icon', 'logo')} type={iconTypes.logoBildControlText} />
        </span>
      </div>
      <div {...bemClasses('imgContainer')}>
        <img {...bemClasses('img')} src={get(pointLevel, `${level}.img`)} alt="" loading="lazy" decoding="async" />
      </div>
      <div {...bemClasses('topic')}>
        <span {...bemClasses('text')} children={display_name} />
      </div>
      <Row {...bemClasses('row', 'points')}>
        <Col {...bemClasses('col', 'text')} allPr={0}>
          <span {...bemClasses('text')} children={textChangeStatus} />
        </Col>
        {!status_ready &&
          <Col {...bemClasses('col', 'points')} allAuto allPr={0}>
            <div {...bemClasses('pointsText')} children={pointsTxt} />
          </Col>
        }
      </Row>
    </div>
  );
  // const complexTree = get(project, 'tree');
  const isDesktop = this.state.device === 'desktop';
  const bottomBlocks = (
    <>
      {renderStocksLC.call(
        this, stocksLC, bemClasses, isDesktop,
        { rel: null, noRedirector: true, external: true, blank: true }
      )}
      <Container body>
        {/*
        {contentBlock(
          blocksConfig,
          'bottom1',
          this.props,
          { wrapper: BottomBlockWrapper, withContainer: false }
        )}
        {contentBlock(
          blocksConfig,
          'bottom2',
          this.props,
          { wrapper: BottomBlockWrapper, withContainer: false }
        )}
        */}
        <div {...bemClasses('blockBanner')}>
          <Link
            {...bemClasses('link')}
            builder={linksBild.sectionBild}
            builderProps={{ title: 'Bild.ua' }}
            noRedirector
            external
            blank
          >
            <picture {...bemClasses('picture')}>
              <source media="(max-width: 767px)" srcSet={imgBannerPhone} />
              <source media="(max-width: 1249px)" srcSet={imgBannerTablet} />
              <img {...bemClasses('img', 'auto')} src={imgBanner} alt="bild.ua" loading="lazy" decoding="async" />
            </picture>
          </Link>
        </div>
        <BannerTelegram {...bemClasses('bannerTelegram')} />
        {/*
        {contentBlock(
          blocksConfig,
          'bottom3',
          this.props,
          { wrapper: BottomBlockWrapper, withContainer: false }
        )}
        */}
      </Container>
    </>
  );
  const pdfLink = (
    <Link
      {...bemClasses('link', 'toExample')}
      title={i18n('linkToExampleTitle')}
      href={i18n('urlToPdf')}
      external
      blank
    >
      <span {...bemClasses('linkContent')}>
        <span {...bemClasses('text')} children={i18n('linkToExampleTitle')} />
      </span>
    </Link>
  );
  const refOrder = <div ref={(ref) => this.makeOrderRef = ref} />;
  const diffDays = difDays(reliability_date_actualize || reliability_date_first_published);
  const enableOnlyReport = true; //Number.isInteger(diffDays) && diffDays <= 30;
  let defaultProducts = products.onlyReport;
    //enableOnlyReport ? products.onlyReport : products.actualization;

  if (!reliability_to_publish) defaultProducts = products.reportNA;

  return (
    <>
      <ReliabilityIndexBillingContainer
        orderBlock={OrderBlock}
        productNames={products.allProducts}
        defaultProducts={defaultProducts}
        orderId={orderId}
        itemIds={[project.id]}
        promocode={promocode}
        orderBlockProps={{
          livingComplexData: project,
          bottomBlocks,
          pdfLink,
          firstPreviewPage,
          scrollTo: this.scrollTo,
          refOrder,
          status_ready,
          levelNA,
          enableOnlyReport
        }}
        marketstatEvent="requestReport"
        saveAdvDataKey="reliabilityOrder"
        ref={ref => this.makeOrderRef = ref}
      />
    </>
  );
}

class ReliabilityIndexBillingContainer extends BillingContainer {
  _buildProductsIdx = (products) => {
    const idx = {};
    each(products, (val) => {
      idx[val.sys_name] = val;
    });
    this.setState({
      amount: 0,
      products: idx,
    }, this._requestAmount);
  };
}

@I18nHoc(translates())
class OrderBlock extends AbstractOrderBlock {
  defineProductsSet(selectedProducts) {
    let productsSet = 'actualization';

    forEach(products, (productsGroup, key) => {
      if (JSON.stringify(productsGroup) === JSON.stringify(selectedProducts)) {
        productsSet = key;
      }
    });

    return productsSet;
  }

  handlePayClick = () => {
    const userEmail = get(this, 'props.advData.email');
    const userPhone = get(this, 'props.advData.phone');

    if (!userEmail || !userPhone) {
      return Notification.error(this.i18n('fieldsMailAndPhoneRequired'));
    }
    this.props.handleOrder();
  };

  renderContent = (formOrder) => {
    const { otherProps = {}, amount } = this.props;
    const {
      bottomBlocks, pdfLink, firstPreviewPage, refOrder, status_ready, levelNA, livingComplexData
    } = otherProps;
    const freeOrder = +amount === 0;
    // const pdf_page_quantity = get(livingComplexData, 'pdf_page_quantity', null);

    return (
      <>
        <div {...bemClasses('white')}>
          <Container body>
            <div {...bemClasses('blockMakeOrder')}>
              <Row {...bemClasses('row', 'makeOrder')} mpColumn>
                <Col {...bemClasses('col', 'pdf')} allFlex allColumn allPr={0} allAlignICenter={status_ready} mdCw={!status_ready && 50} mtCw={!status_ready && 50}>
                  <div {...bemClasses('colContent')}>
                    {firstPreviewPage}
                    <Row {...bemClasses('pdfAfter')}>
                      <Col allPr={0} children={!freeOrder && pdfLink} />
                    </Row>
                    {!status_ready && !levelNA &&
                      <div {...bemClasses('pdfAfterText')}>
                        <Trans lang="ru">
                          <p {...bemClasses('text', 'description')} children="Важно! Анализ реестра судебных решений, налоговый долг и лицензия генподрядчика не учитываются в расчете Индекса надёжности в связи с их высокой субъективностью." />
                          <p {...bemClasses('text', 'description')} children="Эти данные подробно изложены в детальном отчёте и выводы об их возможном влиянии на надёжность ЖК вы можете сделать самостоятельно." />
                        </Trans>
                        <Trans lang="ua">
                          <p {...bemClasses('text', 'description')} children="Важливо! Аналіз реєстру судових рішень, податковий борг і ліцензія генпідрядника не враховуються в розрахунку Індексу надійності в зв'язку з їх високою суб'єктивністю." />
                          <p {...bemClasses('text', 'description')} children="Ці дані докладно викладені в детальному звіті і висновки про їх можливий вплив на надійність ЖК ви можете зробити самостійно." />
                        </Trans>
                      </div>
                    }
                  </div>
                </Col>
                {!status_ready &&
                  <Col {...bemClasses('col', 'form')} allPr={0} mdCw={50} mtCw={50}>
                    {refOrder}
                    {formOrder}
                  </Col>
                }
              </Row>
            </div>
            <div {...bemClasses('blockConclusion')}>
              {!status_ready &&
                <>
                  {blockConclusionMain.call(this)}
                  {!freeOrder && blockConclusionAll.call(this, livingComplexData)}
                </>
              }
            </div>
          </Container>
        </div>
        {!freeOrder && bottomBlocks}
      </>
    );
  };

  scrollTo = () => {
    const { otherProps = {} } = this.props;
    const scrollToFunc = get(otherProps, 'scrollTo');

    if (typeof (scrollToFunc) === 'function') scrollToFunc();
  };

  changeProducts =(products)=> {
    this.props.handleSetProducts(products);
  };

  setActualization =()=> this.changeProducts([
    BillingProducts.RELIABILITY_ACTUALIZE,
    BillingProducts.RELIABILITY_REPORT
  ]);

  setActualizationAndConsult =()=> this.changeProducts([
    BillingProducts.RELIABILITY_ACTUALIZE,
    BillingProducts.RELIABILITY_REPORT,
    BillingProducts.RELIABILITY_CONSULTATION,
  ]);

  setReportNA =()=> this.changeProducts(products.reportNA);

  setReportNAAndConsult =()=> this.changeProducts(products.reportNAAndConsult);

  setOnlyReport =()=> this.changeProducts(products.onlyReport);

  getTxtAboveForm =()=> {
    const { i18n } = this;
    const { otherProps = {}, amount } = this.props;
    const { livingComplexData = {} } = otherProps;
    const {
      reliability_to_publish, display_name, // reliability_date_user_edit,
      reliability_date_first_published, reliability_date_actualize
    } = livingComplexData;
    const freeOrder = +amount === 0;
    const orderTxt = reliability_to_publish ? (
      <>
        <Trans lang="ru">
          <p children={`Подробное исследование надёжности ${display_name}.`} />
          {!freeOrder && <p children="Заполните данные и мы пришлём существующий отчёт на указанный адрес электронной почты сразу после оплаты." />}
          {freeOrder && <p children="Заполните данные и мы пришлём существующий отчёт на указанный адрес электронной почты. Сотрудник ОП застройщика свяжется с вами, чтобы ответить на возможные вопросы." />}
        </Trans>
        <Trans lang="ua">
          <p children={`Докладне дослідження надійності ${display_name}.`} />
          {!freeOrder && <p children="Заповніть дані і ми надішлемо наявний звіт на вказану адресу електронної пошти відразу після оплати." />}
          {freeOrder && <p children="Заповніть дані і ми надішлемо наявний звіт на вказану адресу електронної пошти. Співробітник ВП забудовника зв'яжеться з вами, щоб відповісти на можливі запитання." />}
        </Trans>
        {reliability_date_first_published && !reliability_date_actualize &&
          <p children={`${i18n('reportCreated')} ${formatDate({
            date: get(reliability_date_first_published.split(' '), '[0]'), format: 'dd.mm.yyyy'
          })}`} />
        }
        {reliability_date_actualize &&
          <p children={`${i18n('reportUpdated')} ${formatDate({
            date: get(reliability_date_actualize.split(' '), '[0]'), format: 'dd.mm.yyyy'
          })}`} />
        }
      </>
    ) : (
      <>
        <Trans lang="ru">
          <p children="Мы еще не провели оценку этого ЖК, но вы можете ее заказать." />
          <p children="Заполните данные и заявка поступит в обработку сразу после оплаты." />
          <p children="В течение 3х рабочих дней мы проведём оценку и пришлём отчёт на указанный адрес электронной почты." />
        </Trans>
        <Trans lang="ua">
          <p children="Ми ще не провели оцінку цього ЖК, але ви можете її замовити." />
          <p children="Заповніть дані і заявка надійде в обробку відразу після оплати." />
          <p children="Протягом 3-х робочих днів ми проведемо оцінку і надішлемо звіт на вказану адресу електронної пошти." />
        </Trans>
      </>
    );

    return orderTxt;
  };

  renderTooltip() {
    return (
      <Tooltip
        {...bemClasses('tooltip')}
        trigger="click"
        titleHtml={
          <div {...bemClasses('tooltipContent')}>
            <p children="Мы актуализируем всю правовую и репутационную информацию из официальных источников и реестров. Мы обновляем Извлечение из Реестра вещных прав, если ему больше чем 21 день от даты заказа отчёта." />
            <p children="Почему это важно?" />
            <p children="Ситуация по интересующему вас объекту может измениться в любой момент: появятся арест, ипотека, закончится срок действия договора аренды земли, аннулируют разрешение на строительство или застройщик предоставит новые документы." />
          </div>
        }
      >
        <Icon {...bemClasses('icon', 'tooltipHelp')} title="Зачем?" type={iconTypes.help} />
      </Tooltip>
    );
  }

  renderTooltipUA() {
    return (
      <Tooltip
        {...bemClasses('tooltip')}
        trigger="click"
        titleHtml={
          <div {...bemClasses('tooltipContent')}>
            <p children="Ми актуалізуємо всю правову і репутаційну інформацію з офіційних джерел і реєстрів. Ми оновлюємо Витяг з Реєстру речових прав, якщо йому більше ніж 21 день від дати замовлення звіту." />
            <p children="Чому це важливо?" />
            <p children="Ситуація по об'єкту, який вас цікавить може змінитися в будь-який момент: з'являться арешт, іпотека, закінчиться термін дії договору оренди землі, анулюють дозвіл на будівництво або забудовник надасть нові документи." />
          </div>
        }
      >
        <Icon {...bemClasses('icon', 'tooltipHelp')} title="Навіщо?" type={iconTypes.help} />
      </Tooltip>
    );
  }

  renderOrder(status) {
    const { i18n } = this;
    const pUrgency = this.props.products[BillingProducts.RELIABILITY_URGENCY];
    const { otherProps = {}, selectedProducts, amount, handleSelectProduct } = this.props;
    const productsSet = this.defineProductsSet(selectedProducts);
    const { livingComplexData = {}, enableOnlyReport } = otherProps;
    const { reliability_to_publish } = livingComplexData;
    const freeOrder = +amount === 0;
    const orderTxt = this.getTxtAboveForm();
    const isSelectedUrgency = (selectedProducts.indexOf(get(pUrgency, 'sys_name')) > -1);
    const btnTxt = freeOrder ? `${i18n('get')}${i18n('detailedReport')}` : i18n('goPayment');

    if (!reliability_to_publish) {
      return this.renderContent(
        <div>
          <Trans lang="ru">
            <div children="В связи с войной в стране не работают открытые реестры, и мы не можем предоставить вам актуальные данные." />
          </Trans>
          <Trans lang="ua">
            <div children="У зв'язку з війною, в країні не працюють відкриті реєстри, і ми не можемо  надати вам актуальні дані." />
          </Trans>
        </div>
      );
    }

    const formOrder = (
      <>
        <Row {...bemClasses('rowTopic')}>
          <Col {...bemClasses('col')} allPr={0}>
            <div {...bemClasses('text', 'h2')}><h2 children={i18n('detailedReportH2')} /></div>
          </Col>
        </Row>
        <div {...bemClasses('text', 'description')}>
          {orderTxt}
          <div {...bemClasses('form')}>
            <Input
              {...bemClasses('input')}
              value={this.props.advData.name || ''}
              onChange={val => this.props.handleChangeAdvData('name', val)}
              schema={{ placeholder: i18n('name'), required: true }}
              noLabel
            />
            <PhoneInput
              {...bemClasses('input')}
              value={this.props.advData.phone || ''}
              onChange={val => this.props.handleChangeAdvData('phone', val)}
              schema={{ placeholder: 'Телефон', required: true }}
              noElementBefore
              noLabel
            />
            <Input
              {...bemClasses('input')}
              value={this.props.advData.email || ''}
              onChange={val => this.props.handleChangeAdvData('email', val)}
              schema={{ placeholder: 'E-Mail', required: true }}
              noLabel
            />
            <Input
              {...bemClasses('input')}
              onChange={val => this.props.handleChangeAdvData('question', val, true)}
              schema={{ placeholder: i18n('orderComment') }}
              noLabel
            />
            {!reliability_to_publish &&
              <>
                <div>
                  <Checkbox
                    value={productsSet === 'reportNA'}
                    onChange={this.setReportNA}
                    schema={{ label: i18n('report') }}
                    withIcon
                    noPadding
                    noError
                  />
                </div>
                {productsSet === 'reportNA' &&
                  <div {...bemClasses('inputDesc')}>
                    <Trans lang="ru">
                      <div children="В течение 3х рабочих дней мы проведём оценку и пришлём отчёт на указанный адрес электронной почты." />
                    </Trans>
                    <Trans lang="ua">
                      <div children="Протягом 3-х робочих днів ми проведемо оцінку і надішлемо звіт на вказану адресу електронної пошти." />
                    </Trans>
                  </div>
                }
                <div>
                  <Checkbox
                    value={productsSet === 'reportNAAndConsult'}
                    onChange={this.setReportNAAndConsult}
                    schema={{ label: `${i18n('report')} + ${i18n('consultation')}` }}
                    withIcon
                    noPadding
                    noError
                  />
                </div>
                {productsSet === 'reportNAAndConsult' &&
                  <div {...bemClasses('inputDesc')}>
                    <Trans lang="ru">
                      <div children="После производства отчёта, эксперт свяжется с вами по телефону, чтоб разъяснить содержание отчёта и ответить на ваши вопросы." />
                    </Trans>
                    <Trans lang="ua">
                      <div children="Після виробництва звіту, експерт зв'яжеться з вами по телефону, щоб роз'яснити зміст звіту і відповісти на ваші запитання." />
                    </Trans>
                  </div>
                }
              </>
            }
            {reliability_to_publish &&
              <>
                <Trans lang="ru">
                  <div><b>В связи с войной в стране не работают открытые реестры, и мы не можем предоставить вам актуальные данные. Поэтому вы можете получить существующий отчет бесплатно.</b></div>
                </Trans>
                <Trans lang="ua">
                  <div><b>У зв'язку з війною, в країні не працюють відкриті реєстри, і ми не можемо  надати вам актуальні дані. Тому ви можете отримати існуючий звіт безкоштовно.</b></div>
                </Trans>
              </>
            }
            {false && reliability_to_publish &&
              <>
                {enableOnlyReport &&
                  <div>
                    <Checkbox
                      value={productsSet === 'onlyReport'}
                      onChange={this.setOnlyReport}
                      schema={{ label: `${i18n('report')} ${i18n('withoutActualization')}` }}
                      withIcon
                      noPadding
                      noError
                    />
                  </div>
                }
                {productsSet === 'onlyReport' && enableOnlyReport &&
                  <div {...bemClasses('inputDesc')}>
                    <Trans lang="ru">
                      <div children="С момента актуализации отчёта не прошло 30и дней. Вы можете заказать отчёт без услуги актуализации данных." />
                    </Trans>
                    <Trans lang="ua">
                      <div children="З моменту актуалізації звіту не минуло 30ти днів. Ви можете замовити звіт без послуги актуалізації даних." />
                    </Trans>
                  </div>
                }
                <div>
                  <Checkbox
                    value={productsSet === 'actualization' || productsSet === 'actualizationUrgency'}
                    onChange={this.setActualization}
                    schema={{ label: `${i18n('report')} + ${i18n('actualizationTxt')}` }}
                    withIcon
                    noPadding
                    noError
                  />
                </div>
                {(productsSet === 'actualization' || productsSet === 'actualizationUrgency') &&
                  <div {...bemClasses('inputDesc')}>
                    <Trans lang="ru">
                      <div>
                        В течение 3х рабочих дней мы проверим и обновим все данные отчёта и
                        пришлём вам его повторно.
                        {this.renderTooltip()}
                      </div>
                    </Trans>
                    <Trans lang="ua">
                      <div>
                        Протягом 3-х робочих днів ми перевіримо і оновимо всі дані звіту та
                        надішлемо вам його повторно.
                        {this.renderTooltipUA()}
                      </div>
                    </Trans>
                  </div>
                }
                {!freeOrder &&
                  <>
                    <div>
                      <Checkbox
                        value={productsSet === 'actualizationAndConsult' || productsSet === 'actualizationAndConsultAndUrgency'}
                        onChange={this.setActualizationAndConsult}
                        schema={{ label: `${i18n('report')} + ${i18n('actualizationTxt')} + ${i18n('consultation')}` }}
                        withIcon
                        noPadding
                        noError
                      />
                    </div>
                    {(productsSet === 'actualizationAndConsult' || productsSet === 'actualizationAndConsultAndUrgency') &&
                      <div {...bemClasses('inputDesc')}>
                        <Trans lang="ru">
                          <div children="После актуализации отчёта, эксперт свяжется с вами по телефону, чтоб разъяснить содержание отчёта и ответить на ваши вопросы." />
                        </Trans>
                        <Trans lang="ua">
                          <div children="Після актуалізації звіту, експерт зв'яжеться з вами по телефону, щоб роз'яснити зміст звіту та відповісти на ваші питання." />
                        </Trans>
                      </div>
                    }
                    {productsSet !== 'onlyReport' && reliability_to_publish &&
                      <div>
                        <Checkbox
                          value={isSelectedUrgency}
                          onChange={val => handleSelectProduct(pUrgency.sys_name, val)}
                          schema={{ label: i18n('urgent') }}
                          withIcon
                          noPadding
                          noError
                        />
                      </div>
                    }
                    {isSelectedUrgency &&
                      <div {...bemClasses('inputDesc')}>
                        <Trans lang="ru">
                          <div children={'Ваш заказ будет реализован в течении 24х\u00a0часов после оплаты, без учёта выходных.'} />
                        </Trans>
                        <Trans lang="ua">
                          <div children={'Ваше замовлення буде реалізовано протягом 24х\u00a0годин після оплати, без урахування вихідних.'} />
                        </Trans>
                      </div>
                    }
                  </>
                }
              </>
            }
            <div {...bemClasses('price')}>
              <span
                {...bemClasses('text', 'price')}
                children={amount ? `${amount}\u00a0грн` : i18n('isFree')}
              />
            </div>
            <Button
              {...bemClasses('btn', 'submit')}
              title={btnTxt}
              onClick={this.handlePayClick}
              customRenderer
            >
              <span {...bemClasses('btnContent')}>
                <span {...bemClasses('after')} />
                <span {...bemClasses('text')} children={btnTxt} />
              </span>
            </Button>
            <div {...bemClasses('inputDesc')}>
              <Trans lang="ru">
                <div>
                  {'Подтверждая заказ, я принимаю условия\u0020'}
                  <Link
                    {...bemClasses('link', 'toTerms')}
                    builder={linksBildControl.sectionTerms}
                    builderProps={{ title: 'Пользовательское соглашение' }}
                    external
                  >
                    <span {...bemClasses('linkContent')}>
                      <span {...bemClasses('text')} children="пользовательского соглашения" />
                    </span>
                  </Link>
                </div>
              </Trans>
              <Trans lang="ua">
                <div>
                  {'Підтверджуючи замовлення, я приймаю умови\u0020'}
                  <Link
                    {...bemClasses('link', 'toTerms')}
                    builder={linksBildControl.sectionTerms}
                    builderProps={{ title: 'Угода користувача' }}
                    external
                  >
                    <span {...bemClasses('linkContent')}>
                      <span {...bemClasses('text')} children="угоди користувача" />
                    </span>
                  </Link>
                </div>
              </Trans>
            </div>
          </div>
          {status === 'rejected' &&
            <p>
              <Trans lang="ru" children="Оплата не зачислена. Чтобы узнать причину - обратитесь в свой банк." />
              <Trans lang="ua" children="Плата не зарахована. Щоб дізнатися причину - зверніться до свого банку." />
            </p>
          }
        </div>
      </>
    );

    return this.renderContent(formOrder);
  }

  renderPay() {
    const formOrder = (
      <div {...bemClasses('text', 'description')}>
        <p>
          <Trans lang="ru" children="Запуск процесса оплаты..." />
          <Trans lang="ua" children="Запуск процесу сплати ..." />
        </p>
      </div>
    );

    return this.renderContent(formOrder);
  }

  renderPayWait() {
    const formOrder = (
      <>
        <Trans lang="ru">
          <Row {...bemClasses('rowTopic')}>
            <Col {...bemClasses('col')} allPr={0}>
              <div {...bemClasses('text', 'h2')}><h2 children="Оплата ожидает подтверждения" /></div>
            </Col>
          </Row>
          <div {...bemClasses('text', 'description')}>
            <p children="Ваш заказ поступит в обработку после зачисления оплаты." />
            <p children="Спасибо." />
          </div>
        </Trans>
        <Trans lang="ua">
          <Row {...bemClasses('rowTopic')}>
            <Col {...bemClasses('col')} allPr={0}>
              <div {...bemClasses('text', 'h2')}><h2 children="Оплата очікує підтвердження" /></div>
            </Col>
          </Row>
          <div {...bemClasses('text', 'description')}>
            <p children="Ваше замовлення надійде в обробку після зарахування оплати." />
            <p children="Дякуємо." />
          </div>
        </Trans>
      </>
    );

    return this.renderContent(formOrder);
  }

  renderPayed() {
    const { i18n } = this;
    const { orderData } = this.props;
    const selectedProducts = orderData.order_products || [];
    const productsSet = this.defineProductsSet(selectedProducts);
    const notificationText =i18n(productsSet);

    const formOrder = (
      <>
        {Notification.success(notificationText, null, 10)}
        <Row {...bemClasses('rowTopic')}>
          <Col {...bemClasses('col')} allPr={0}>
            <div {...bemClasses('text', 'h2')}><h2 children={i18n('orderSuccess')} /></div>
          </Col>
        </Row>
        <div {...bemClasses('text', 'description')} children={notificationText} />
      </>
    );

    return this.renderContent(formOrder);
  }

  renderRejected() {
    return this.renderOrder('rejected');
  }
}
